import { createStore } from 'vuex'

// Create a new store instance.
export default createStore({
  state() {
    return {
      isLoading: false,
      clientId: JSON.parse(sessionStorage.getItem("clientId")),
      user: JSON.parse(sessionStorage.getItem("user")),
    }
  },
  actions: {
    setLoading(context, payload) {
      context.commit('Set_Loading', payload);
    },
    setClientId(context, payload) {
      context.commit('Set_ClientId', payload);
    },
    setUser(context, payload) {
      context.commit('Set_User', payload);
    },
    

  },
  mutations: {
    Set_Loading(state, payload) {
      state.isLoading = payload;
    },
    Set_ClientId(state, payload) {
      state.clientId = payload;
      sessionStorage.setItem("clientId",  JSON.stringify(payload));
    },
    Set_User(state, payload) {
      state.user = payload;
      sessionStorage.setItem("user",  JSON.stringify(payload));
    },
     
  },
  getters:{
    getIsLoading(state) {
      return state.isLoading;
    },
    getClientId(state) {
      return state.clientId;
    },
    getUser(state) {
      return state.user;
    },
    
  }
})

 